import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "../../config/Constants";
import { getParentPath } from "../../helper";

type TopBarProps = {
  onRoute: (route: string) => void;
  onOpenSidebar: () => void;
  activePath: string;
};

const TopBar = ({ onOpenSidebar }: TopBarProps) => {
  const [activePath, setActivePath] = useState("dashboard");
  let params = useParams();
  const location = useLocation();

  useEffect(() => {
    let path =
      Object.keys(params).length === 0
        ? location.pathname.split("/")[location.pathname.split("/").length - 1]
        : location.pathname.split("/")[location.pathname.split("/").length - 2];

    let parentPath = getParentPath(path);
    setActivePath(parentPath.replace("-", " "));
  }, [location]); // eslint-disable-line
  return (
    <TopBarContainer>
      <div style={{ width: "24px", paddingBottom: "1rem" }}>
        <MenuButton onClick={onOpenSidebar}>
          <img
            src={require("../../assets/images/icn_menu.png")}
            alt="icn_menu"
          />
        </MenuButton>
      </div>
      <div style={{ flex: 1, paddingBottom: "1.25rem" }}>
        <PageHeader className="">{activePath}</PageHeader>
      </div>
      <div style={{ width: "24px" }}></div>
    </TopBarContainer>
  );
};

const TopBarContainer = styled.div`
  height: 6rem;
  background: ${Colors.black};
  display: none;
  padding: 0 1rem;
  @media only screen and (max-width: 768px) {
    display: flex;
  }
  div {
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }
`;

const PageHeader = styled.div`
  color: white;
  text-align: center;
  text-transform: capitalize;
`;

const MenuButton = styled.button`
  background: transparent;
  padding: 0;
  margin: 0;
  border: none;
`;

export default TopBar;
